(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-review"] && !Shopify.designMode) return;
  try {
    
  const icons = document.querySelectorAll('.google-review-wrapper .link-google-star');

  icons.forEach((icon, index) => {
    icon.addEventListener('mouseenter', () => {
      for (let i = 0; i <= index; i++) {
        icons[i].classList.add('hovered');
      }
    });

    icon.addEventListener('mouseleave', () => {
      icons.forEach((icon) => icon.classList.remove('hovered'));
    });
  });

  // Get the current URL including query parameters
  const currentUrl = window.location.href;

  // Select all elements you want to update
  const links = document.querySelectorAll('.add-current-url');

  // Update their href attribute
  links.forEach((link) => {
    link.href =
      'https://docs.google.com/forms/d/e/1FAIpQLSeBsn18TZBavjbt8QD7Um0jo72mPODRzsz4X-bt9yaFtRxa5w/viewform?usp=pp_url&entry.1853110686=' +
      currentUrl;
  });

  } catch(e) { console.error(e); }
})();
})();
